import { z } from 'zod';

const cnpjRegex = /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/;

export const loginSchema = z.object({
  email: z.string().min(1, 'Informe o e-mail').email('E-mail inválido'),
  password: z.string().min(1, 'Informe a senha'),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const registerTenantSchema = z.object({
  companyName: z
    .string()
    .min(3, 'Informe o nome da empresa')
    .max(255, 'Nome muito longo'),
  cnpj: z
    .string()
    .min(1, 'Informe o CNPJ')
    .regex(cnpjRegex, 'CNPJ inválido. Use o formato 00.000.000/0000-00'),
  adminName: z
    .string()
    .min(3, 'Informe seu nome completo')
    .max(120, 'Nome muito longo'),
  adminEmail: z
    .string()
    .min(1, 'Informe seu e-mail')
    .email('E-mail inválido'),
  adminPassword: z
    .string()
    .min(10, 'A senha deve ter no mínimo 10 caracteres')
    .max(100, 'Senha muito longa'),
  adminPhone: z.string().optional(),
  acceptTerms: z
    .boolean()
    .refine((v) => v === true, { message: 'Você precisa aceitar os termos' }),
});

export type RegisterTenantInput = z.infer<typeof registerTenantSchema>;
